// Where a dialog sits, decided by the window rather than by a width-only
// breakpoint: full where the display is small in either direction (a phone
// either way up), a card in the middle of anything bigger. The frame owns all
// four of its edges, so nothing inside it adds a second gutter. §20
export const DIALOG_BASE = 'fixed z-80 flex flex-col overflow-hidden overscroll-none bg-card';

export const DIALOG_FULL = 'inset-0 px-dialog pt-dialog pb-dialog';

export const DIALOG_CARD =
  'top-1/2 left-1/2 h-fit max-h-[calc(100%-4rem)] w-[440px] max-w-[calc(100%-2rem)] -translate-x-1/2 -translate-y-1/2 rounded-2xl border px-dialog pt-dialog pb-dialog shadow-2xl';
